import paginationFactoryModule from 'react-bootstrap-table2-paginator';

export const paginationFactory =
  paginationFactoryModule.default ?? paginationFactoryModule;
